import React from 'react';
import { useTranslation } from "react-i18next";
import HeroSection from '../../components/sections/HeroSection';
import BigTinyIntroSection from '../../components/sections/BigTinyIntroSection';
import OnePlusTwoGallery from '../../components/sections/OnePlusTwoGallery';
import FaqAccordionsSection from '../../components/sections/FaqAccordionsSection';
import FactsAndStatsSection from '../../components/sections/FactsAndStatsSection';
import PracticalInfoSection from '../../components/sections/PracticalInfoSection';
import ArticleWithModal from '../../components/sections/ArticleWithModal';
import VisaServicesPromotion from '../../components/sections/VisaServicesPromotion';
import FooterSection from '../../components/sections/FooterSection';
import DividersInfoSection from '../../components/sections/DividersInfoSection';
import ParallaxCallSection from '../../components/sections/ParallaxCallSection';

function AstanaCityPage(props) {

    var { t } = useTranslation();

    var faqItems = [
        { question: "What documents are required?", answer: "Passport valid for at least 6 months, visa application form, passport photos, proof of accommodation, and travel insurance are standard requirements." },
        { question: "How long does processing take?", answer: "Standard processing usually takes up to 5 working days, while express processing can be completed in 48 hours depending on consular workload." },
        { question: "Can business delegations apply?", answer: "Yes, corporate visa packages are available for delegations, including bulk submissions, account-based invoicing, and consolidated document delivery." },
        { question: "Is visa on arrival available?", answer: "Visa on arrival is limited to specific cases. Pre-application ensures guaranteed entry and avoids administrative delays at the border." }
    ];

    return (
        <>
            <HeroSection
                isExpectingAnimations={true}
                title="Astana - Capital of Opportunity"
                paragraph="Discover Astana, Kazakhstan's futuristic capital. A city of stunning architecture, top-tier universities, and booming industries, offering unparalleled opportunities for students and professionals. Jai makes your journey here seamless."
                callToAction="Start Your Future in Astana!"
                backgroundImageUrl="https://www.hdrshooter.com/wp-content/uploads/2018/10/Astana-IMG_7179-Pano-web_compressed.jpg"
            />
            
            <div className='uk-container'>
                <BigTinyIntroSection
                    centered={false}
                    Big="For ambitious students and skilled workers, Astana is a city where the future is being built today. Jai provides expert guidance for your student or work visa, opening doors to world-class education at institutions like Nazarbayev University and high-demand jobs in construction, government, and technology."
                    Tiny="Imagine studying in a state-of-the-art campus or working on landmark construction projects that shape a nation's skyline. With Jai handling your visa and paperwork, you can focus on your career and education goals in one of the world's most dynamic and rapidly growing capitals."
                />

                <section className="uk-grid-large uk-child-width-1-2@s uk-flex-middle" data-uk-grid>
                    <div>
                        <h1 className="uk-heading-medium uk-text-bold uk-margin-remove">
                            Astana — A Hub of Growth and Innovation
                        </h1>

                        <p className="uk-text-lead uk-margin-small-top">
                            As the nation's capital, Astana is the administrative heart of Kazakhstan and a showcase of 21st-century urban development. Its skyline is a testament to ambitious architectural projects, while its economy is driven by public administration, construction, and a growing service sector.
                        </p>

                        <p>
                            The city is a magnet for talent, hosting major government bodies, state-owned corporations, and international diplomatic missions. This creates a stable, professional environment with a constant need for skilled labor and administrative specialists. Furthermore, Astana is a premier educational destination, home to leading universities that attract students from across the globe.
                        </p>

                        <p>
                            Continuous large-scale construction projects, from residential complexes to public infrastructure, ensure that there is a high and sustained demand for construction workers, engineers, and project managers. This makes Astana a prime location for those seeking stable employment and career advancement in a modern, organized setting.
                        </p>

                        <VisaServicesPromotion />
                    </div>

                    <OnePlusTwoGallery
                        BigImageLink="https://upload.wikimedia.org/wikipedia/ru/thumb/7/78/%D0%90%D1%81%D1%82%D0%B0%D0%BD%D0%B0-%D0%91%D0%B0%D0%B9%D1%82%D0%B5%D1%80%D0%B5%D0%BA_-_panoramio.JPG/1200px-%D0%90%D1%81%D1%82%D0%B0%D0%BD%D0%B0-%D0%91%D0%B0%D0%B9%D1%82%D0%B5%D1%80%D0%B5%D0%BA_-_panoramio.JPG"
                        BigImageDescription="Astana skyline with Bayterek Tower"
                        SmallImage1Link="https://world.uz/files/628dbc09b98c4_118257uu.jpg"
                        SmallImage1Description="Nazarbayev University Campus"
                        SmallImage2Link="https://astana.citypass.kz/wp-content/uploads/%D1%85%D0%B0%D0%BD%D1%88%D0%B0%D1%82%D1%8B%D1%80.jpg"
                        SmallImage2Description="Khan Shatyr Entertainment Center"
                    />

                </section>
            </div>

            <ParallaxCallSection
                URL="https://blog.global-guide.org/wp-content/uploads/2025/02/111-241.jpg"
                headline="Experience the Future in Astana"
                callToAction="Secure your Kazakhstan visa with Jai and discover the nation’s most modern capital — a city of architecture, ambition, and opportunity."
            />

            <div className='uk-container'>
                <section className="uk-grid-large uk-child-width-1-3@m uk-margin-large-top" data-uk-grid>

                    <ArticleWithModal
                        Image="https://tengrinews.kz/userdata/u390/2024-10/resize/8f6207e8c115409aac56c76ee6f17e71.jpeg"
                        ImageDescription="Construction site in Astana"
                        ArticleTitle="Construction & Manual Labour"
                        Paragraph1="Astana is in a state of perpetual growth, with new districts, government buildings, and residential areas constantly under development. This creates a massive, ongoing demand for skilled and semi-skilled manual laborers."
                        Paragraph2="Welders, electricians, plumbers, carpenters, and general construction workers are highly sought after for both public and private projects. Foreign workers are valued for their expertise and work ethic, with many companies offering competitive wages and structured employment contracts."
                        Paragraph3="Jai specializes in facilitating work permits for the construction sector, ensuring you have a legal and secure position. We connect you with reputable employers and handle all the administrative hurdles, so you can start contributing to the capital's growth and building your own future."
                        modalName="modal-work1"
                    />

                    <ArticleWithModal
                        Image="https://inbusiness.kz/uploads/2024-4/hZrxxVV0.webp"
                        ImageDescription="Students at a university in Astana"
                        ArticleTitle="Education & Student Life"
                        Paragraph1="Astana is the educational capital of Kazakhstan, home to prestigious institutions like Nazarbayev University, Astana IT University, and Eurasian National University. These universities offer world-class programs in English and attract a diverse international student body."
                        Paragraph2="Whether you're pursuing a degree in engineering, computer science, international relations, or business, Astana provides a modern and stimulating academic environment. Campuses are equipped with cutting-edge facilities, and the city offers a safe and vibrant student life with numerous cafes, parks, and cultural events."
                        Paragraph3="Our student visa program is designed to make your admission and relocation process as smooth as possible. We assist with university applications, document preparation, and all visa formalities, allowing you to focus on your studies and embrace the incredible learning opportunities in Astana."
                        modalName="modal-education1"
                    />

                    <PracticalInfoSection
                        sectionTitle="Practical Information"
                        currencyInfo="Local currency: Kazakhstani tenge (KZT)."
                        airportInfo="Primary airport: Nursultan Nazarbayev International Airport (NQZ), a major international hub."
                        climateInfo="Climate: extreme continental; very cold, long winters and warm, short summers."
                        businessHoursInfo="Business hours: Government and corporate offices typically 09:00–18:00. Construction sites may have earlier start times."
                    />
                </section>
            </div>

            {/* Quick Facts / Statistics */}
            <FactsAndStatsSection
                sectionTitle="Quick Facts"
                stat1="90%"
                fact1="Visa approval rate"
                stat2="635+"
                fact2="Clients served"
                stat3="14"
                fact3="Days processing time"
                stat4="1830"
                fact4="Year city founded"
            />

            <div className="uk-section uk-container">
                <div className="uk-text-center">
                    <h2 className="uk-h2 uk-text-bold">Your Career Starts in the Capital</h2>
                    <p className="uk-text-lead">
                        Astana's status as the political and administrative center of Kazakhstan creates a unique and stable job market with high demand for specific professional and trade skills.
                    </p>
                </div>

                <div className="uk-child-width-1-3@m uk-grid-match uk-margin-medium-top" data-uk-grid>
                    <div>
                        <div className="uk-card uk-card-body uk-card-hover uk-card-default">
                            <div className="uk-card-badge uk-label">High Demand</div>
                            <h3 className="uk-card-title"><span data-uk-icon="icon: bolt; ratio: 1.2" className="uk-margin-small-right"></span>Construction & Skilled Trades</h3>
                            <p>The city's non-stop expansion fuels a constant need for construction managers, engineers, architects, and skilled tradespeople like welders, electricians, and heavy equipment operators. Major infrastructure projects offer long-term, stable employment.</p>
                        </div>
                    </div>
                    <div>
                        <div className="uk-card uk-card-body uk-card-hover uk-card-default">
                            <h3 className="uk-card-title"><span data-uk-icon="icon: users; ratio: 1.2" className="uk-margin-small-right"></span>Public Sector & Administration</h3>
                            <p>As the capital, Astana is home to all government ministries and state-owned enterprises. This creates opportunities for specialists in public policy, administration, translation, and international relations, particularly for those with foreign language skills.</p>
                        </div>
                    </div>
                    <div>
                        <div className="uk-card uk-card-body uk-card-hover uk-card-default">
                            <h3 className="uk-card-title"><span data-uk-icon="icon: world; ratio: 1.2" className="uk-margin-small-right"></span>Education & IT</h3>
                            <p>With top-tier universities and a growing tech hub, there is strong demand for educators, researchers, and IT professionals. Specialists in software development, cybersecurity, and data science will find a burgeoning market in Astana.</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* FAQ Accordion */}
            <FaqAccordionsSection
                items={faqItems}
            />

            <div className='uk-container'>
                {/* Infosection with shitloads of dividers */}
                <DividersInfoSection />
            </div>

            <FooterSection />
        </>
    );
}

export default AstanaCityPage;